import $ from 'jquery';


const formatPhone = ( value ) => {
  let cleaned = ( '' + value ).replace(/\D/g, '');
  let match = cleaned.match(/^(\d{3})(\d{3})(\d{4})$/);
  if ( match ) {
    return '(' + match[1] + ') ' + match[2] + ' ' + match[3];
  }

  return null;
}

if( $( '.wpcf7-form' ).length  ) {
  const form = document.querySelector('.wpcf7-form')

  form.addEventListener('submit', function(e) {
    for(const element of form.elements) {
      if(element.name === 'tel' || element.name === 'tel-333') {
        const newValue = formatPhone(element.value)
        element.value = formatPhone(element.value)
      }
    }

    gtag_report_conversion();
  
  }, { capture: true });

  $( '.contact-us-form input, .contact-us-form select' ).on( 'focus', ( e ) => {
    let $inputParent = $( e.currentTarget ).closest( '.half-input, .full-input' );
    $inputParent.addClass( 'focused' );
  } )

  $( '.contact-us-form input, .contact-us-form select' ).on( 'blur', ( e ) => {
    let $this = $( e.currentTarget );
    let $inputParent = $this.closest( '.half-input, .full-input' );

    if( $this.val().length == 0 ) {
      $inputParent.removeClass( 'focused' );
    }
  } )
}

const spinnerTextOptions = [ 
  "Great, thanks for the information, I’ll be right back.", 
  "Might take me a couple minutes, just looking through all the plans.",
  "Almost there, hold tight.",
]

let textInterval = null;

document.addEventListener('wpcf7beforesubmit', function(event) {

  let textIndex = 0;
  const updateSpinnerText = () => {
    const newText = `'${spinnerTextOptions[textIndex]}'`;
    document.documentElement.style.setProperty('--wpcf7-spinner-text', newText);
    textIndex = (textIndex + 1) % spinnerTextOptions.length;
  };
  
  textInterval = setInterval(updateSpinnerText, 3000);
  updateSpinnerText(); // Update immediately
  
  // setTimeout(() => {
  //   const spinner = document.querySelector('.wpcf7-spinner');
  //   if (spinner && spinner.offsetParent !== null) {
  //     const newText = "'This may take a few more seconds to complete.'";
  //     document.documentElement.style.setProperty('--wpcf7-spinner-text', newText);
  //     requestAnimationFrame(() => {
  //       const afterStyle = window.getComputedStyle(spinner, '::after');
  //       void afterStyle.content;
  //       // Trigger a reflow
  //       void spinner.offsetHeight;
  //     });
  //   }
  // }, 3000);
});
// Handle recommendations display for form 13828
document.addEventListener('wpcf7mailsent', function(event) {

  const formId = event.detail.contactFormId;
  
  // Check if this is form 13828 (the form with recommendations)
  if (formId == 13828) {
    const response = event.detail.apiResponse;
    const slides = document.querySelectorAll('.slide');
    const slideController = document.querySelector('.slide-controller');
    const progressBar = document.querySelector('.progress-bar');
    const wpcf7ResponseOutput = document.querySelector('.wpcf7-response-output');
    
    // Check if recommendations HTML is in the response (rendered from Blade template)
    if (response && response.recommendations_html) {
      // Get the form element from event.target
      const $form = $(event.target);
      const $responseOutput = $form.find('.suggestions').first();
      
      // Replace the response output with the rendered recommendations HTML
      // $responseOutput.siblings('div').html(response.recommendations_html);
      $responseOutput.empty().html(response.recommendations_html);

      $responseOutput.addClass('recommendations-response');

      if (textInterval !== null) {
        clearInterval(textInterval);
        textInterval = null;
      }

      slides.forEach((slide) => {
        slide.style.display = 'none';
      });

      slideController.style.display = 'none';
      wpcf7ResponseOutput.style.display = 'none';
      progressBar.innerHTML = 'Results';
      
      // Attach event listener to start over button after HTML is inserted
      const startOverButton = document.querySelector('.start-over');
      if (startOverButton) {
        startOverButton.addEventListener('click', (e) => {
          e.preventDefault();
          e.stopPropagation();
          location.reload();
        });
        
        // Also handle clicks on the anchor tag inside the button
        const startOverLink = startOverButton.querySelector('a');
        if (startOverLink) {
          startOverLink.addEventListener('click', (e) => {
            e.preventDefault();
            e.stopPropagation();
            location.reload();
          });
        }
      }
      
    } else if (response && response.recommendations) {
      // Fallback: if HTML not available, log the data
      console.log('Recommendations data:', response.recommendations);
    }
  }
}, false);